import React from "react";
import { useLocation, matchPath, useHistory } from "react-router-dom";
import { Flex, Text, Box } from "rebass";
export const NavBar: React.FC<{
  navOptions: { path: string; label: string }[];
}> = ({ navOptions }) => {
  const location = useLocation();
  const history = useHistory();

  return (
    <Flex>
      {navOptions.map((o) => {
        const isActivePath = !!matchPath(location.pathname, {
          path: o.path,
          exact: true,
        });

        return (
          <Box
            onClick={() => {
              history.push(o.path);
            }}
            key={o.label}
            marginLeft={"2px"}
            marginTop={3}
            marginBottom={3}
          >
            <Text
              sx={{
                borderBottom: isActivePath ? "solid 3px #3F90B5" : "",
                cursor: "pointer",
              }}
              fontWeight="bold"
              marginRight={3}
            >
              {o.label}
            </Text>
          </Box>
        );
      })}
    </Flex>
  );
};
